module.exports = __webpack_public_path__ + "media/taVideo2.d88dd263.mp4";